
import React, { Component } from 'react';

import ConnectGroupImg from '../../assets/images/ministries/ConnectGroup.jpg';

class ConnectGroups extends Component {
  render() {
    return (
      <section>
        <header id="page-title">
          <div className="container">
            <h1>Connect Groups</h1>
          </div>
        </header>
        <section className="container">
          <img src={ConnectGroupImg} style={{ float: "right" }} alt="" />
          <p>Perhaps the most important structure of CRCK’s life is the Connect Groups we run during the week.</p>

          <p>A Connect Group is a small group of people who meet together weekly to:
            <ul>
              <li>Read the Bible</li>
              <li>Pray in response to what we've learned;</li>
              <li>Share our lives with each other</li>
              <li>Serve our church and community together</li>
            </ul>
          </p>

          {/*<p><strong>Even with coronavirus social distancing, our Connect Groups are still meeting throughout the week on various days, at various times, using the online meeting platform Zoom</strong></p>*/}
          <p>Connect Groups meet throughout the week at various times and in various locations in Kingston and Hobart. We also have the following special groups;
            <ul>
              <li>Transit ‘Young Adults’ group for people aged between 18 and 24 (Tuesday 7:30pm).</li>
            </ul></p>
          <br />
          <p>It is God’s great blessing that, when we join his family, he gives us to each other as brothers and sisters.
            Connect Groups are our primary means of cultivating relationships between ‘spiritual sibling’s and between us and God, and Bible reading, prayer, sharing of ourselves and serving others are their core business.
          </p>

          <p>If you would like to join a Connect Group, or just visit one to check it out, please contact <a href="mailto:juliacking@googlemail.com">juliacking@googlemail.com</a> or call the church office.</p>



        </section>
      </section>
    );
  }
}

export default ConnectGroups;
